import { preffixTestIds } from 'utility/e2e'

export const AssetFilterTestId = preffixTestIds('asset-filter')({
  DROPDOWN_SELECT_PREFIX: (traitKey: string) => `select-${traitKey}`,
  FILTERS_ROW: 'row',
  CLEAR_FILTERS_BTN: 'clear',
  OPEN_TEXT_FIELD: 'open-text-field',
})
